import { getHublet } from '../store/app/selectors';
import { isPortalIdDefined } from '../store/auth/selectors';
import { isNewLoggedInAccount } from './endpointStateChecks';
import { EndpointKey } from './EndpointKey';
import { getIsActiveAndAssignedToVariant, getParameter } from '../store/experiments/selectors';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import Logger from '../lib/Logger';
import { getSentryExtra } from '../error/getSentryExtra';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { getEndpointRetries } from '../store/http-responses/selectors';
import { writeHubUserAttribute } from '../utils/hubUserAttribute';
import { Tracker } from '../store/tracking/action-creators';
const ACQ0143_TREATMENT_HUB_USER_ATTRIBUTE_KEY = 'GrowthOnboardingSetup:ACQ0143NewSignupOnboardingFlowTreatment';
const storeAcq143Treatment = state => {
  const hublet = getHublet(state);
  const freeStarterRelaunchTreatment = getParameter(state, ExperimentKeys.ACQ0143);
  return writeHubUserAttribute(ACQ0143_TREATMENT_HUB_USER_ATTRIBUTE_KEY, freeStarterRelaunchTreatment, hublet);
};
export const LOG = Logger.getLogger('storeAcq143TreatmentError');
export const EndpointsStoreAcq143Treatment = {
  [EndpointKey.StoreAcq143Treatment]: {
    isStateOnlyTrigger: true,
    once: true,
    stateCheck: state =>
    // Is the Portal created so we can use the Hub User Attributes API?
    isPortalIdDefined(state) &&
    // Is the user in the ACQ0143 Free Starter Relaunch experiment?
    getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0143, [ExperimentParameterGroup.Variant_A, ExperimentParameterGroup.Control]) &&
    // Is the user authed for API usage?
    isNewLoggedInAccount(state),
    method: storeAcq143Treatment,
    handleSuccess: (response, dispatch) => {
      dispatch(Tracker.signupInteraction('success-store-acq143-treatment-onboarding-setup'));
    },
    handleError: (error, dispatch, getState) => {
      dispatch(Tracker.signupInteraction('error-store-acq143-treatment-onboarding-setup'));
      const numberOfStoreTreatmentRetries = getEndpointRetries(getState(), EndpointKey.StoreAcq143Treatment);
      LOG.error('Storing ACQ0143 treatment error', {
        extra: Object.assign({}, getSentryExtra(error), {
          totalNumberOfCalls: numberOfStoreTreatmentRetries
        })
      });
      // Retry every second, up to 5 times
      if (numberOfStoreTreatmentRetries < 5) {
        dispatch(Tracker.signupInteraction('retry-store-acq143-treatment-onboarding-setup', {
          totalNumberOfCalls: numberOfStoreTreatmentRetries
        }));
        dispatch(retryEndpoint(EndpointKey.StoreAcq143Treatment, 1000));
      }
    }
  }
};